import { shallowMount } from "@vue/test-utils";
import MensajeVeridas from "@/views/MensajeVeridas";

describe("MensajeVeridas component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(MensajeVeridas);
  });

  it("Renders del component MensajeVeridas", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
